/**
 * Een alinea zoals het model hem schrijft, netjes op het scherm.
 *
 * Het model zet een kopje als **vet** aan het begin van een alinea, en soms
 * een #. Er waren drie functies die dat elk anders afhandelden: formatText
 * (kopje schuin met een witregel erna), highlightPassage (# weg, maar **
 * bleef staan) en stripMarkdown (alleen # weg). Nu is het één.
 *
 *   <OpgemaakteTekst tekst={alinea} />                      kopje schuin, # weg
 *   <OpgemaakteTekst tekst={alinea} markeer={passage} />    en de passage geel
 *
 * zonderKopjes() is voor waar de tekst bewerkt wordt: daar moet hij leesbaar
 * zijn zonder de tekens ervoor.
 */
import React from 'react';

export function zonderKopjes(tekst) {
  if (!tekst) return tekst;
  return tekst.replace(/^#+\s*/gm, '');
}

/** Een geheel van tekst en vet: **kopje** wordt een schuin kopje met een witregel. */
function metKopjes(tekst, sleutel) {
  return tekst.split(/(\*\*[^*]+\*\*)/g).map((deel, i) => {
    if (deel.startsWith('**') && deel.endsWith('**')) {
      return <span key={`${sleutel}-${i}`}><em style={{ fontStyle: 'italic' }}>{deel.slice(2, -2)}</em><br /></span>;
    }
    return deel;
  });
}

/**
 * Waar staat de passage in de tekst? Eerst letterlijk (zonder op hoofdletters
 * te letten); anders de eerste dertig tekens, tot het einde van die zin.
 */
export function zoekPassage(tekst, passage) {
  if (!passage || !tekst) return null;
  const gezocht = passage.trim();
  const plek = tekst.toLowerCase().indexOf(gezocht.toLowerCase());
  if (plek !== -1) return [plek, plek + gezocht.length];

  const begin = gezocht.substring(0, 30);
  const deelPlek = tekst.toLowerCase().indexOf(begin.toLowerCase());
  if (deelPlek === -1) return null;
  let eind = tekst.indexOf('.', deelPlek + begin.length);
  if (eind === -1 || eind > deelPlek + gezocht.length + 50) {
    eind = deelPlek + gezocht.length;
  } else {
    eind += 1;
  }
  return [deelPlek, eind];
}

export function OpgemaakteTekst({ tekst, markeer }) {
  if (!tekst) return null;
  const schoon = zonderKopjes(tekst);
  const plek = zoekPassage(schoon, markeer);
  if (!plek) return <>{metKopjes(schoon, 't')}</>;
  const [van, tot] = plek;
  return (
    <>
      {metKopjes(schoon.substring(0, van), 'voor')}
      <mark style={{ background: 'var(--markeer)', padding: '2px 4px', borderRadius: '2px' }}>{schoon.substring(van, tot)}</mark>
      {metKopjes(schoon.substring(tot), 'na')}
    </>
  );
}
